import React, { ReactNode } from 'react';
import styles from './assets/wage-screen.module.scss';
import classNames from 'classnames';
import WagesGrid from './components/WagesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateWageButton from './components/CreateWageButton';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IWage } from 'src/types/wage';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IWage>;
    inProgress: boolean;
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class WagesList extends React.Component<Props> {
    componentDidMount() {
        this.props.getProviders({});
    }
    public render(): ReactNode {
        const { data, getData, inProgress, providers } = this.props;

        return (
            <RoleLayout>
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>
                        FIXED SALARY {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    {inProgress ? <Loader /> : null}
                    <CreateWageButton />
                </div>
                <div className={classNames(styles.list)}>
                    <WagesGrid providers={providers} data={data} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default WagesList;
